import {connect} from 'react-redux';
import {bindActionCreators} from 'redux';
import {compose, lifecycle} from 'recompose';

import {setWrappedDisplayName} from '@webex/react-component-utils';

import {connectToMercury} from './actions';

function setupMercury(props) {
  const {
    mercury,
    sparkInstance,
    sparkState
  } = props;

  if (sparkInstance
    && sparkState.get('authenticated')
    && sparkState.get('registered')
    && !sparkState.get('hasError')
    && !mercury.getIn(['status', 'hasConnected'])
    && !mercury.getIn(['status', 'isConnecting'])
    && !mercury.getIn(['status', 'isConnected'])
    && sparkInstance.internal.device.registered
  ) {
    props.connectToMercury(sparkInstance);
  }
}

export default compose(
  setWrappedDisplayName('WithMercury'),
  connect(
    (state) => state,
    (dispatch) => bindActionCreators({
      connectToMercury
    }, dispatch)
  ),
  lifecycle({
    componentWillReceiveProps(nextProps) {
      setupMercury(nextProps);
    }
  })
);
